import { render, staticRenderFns } from "./BookingGraphChart.vue?vue&type=template&id=51059b8a&"
import script from "./BookingGraphChart.vue?vue&type=script&lang=js&"
export * from "./BookingGraphChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports